// PhoneNumberValidation.js
const validatePhoneNumber = (phoneNumber, callback) => {
    // Define your phone number validation logic here (e.g., regex)
    const phoneRegex = /^\d{10}$/;

    // Use a timeout of 500 milliseconds (adjust as needed)
    let timeoutId;
    const delay = 1000;

    // Clear previous timeout
    clearTimeout(timeoutId);

    // Set a new timeout
    timeoutId = setTimeout(() => {
        const isValid = phoneRegex.test(phoneNumber);
        callback(isValid);
    }, delay);
};

export default validatePhoneNumber;
